import React from "react";
import { useTranslation } from "react-i18next";
import type { HelpArticle } from "./types";

interface HelpArticleViewProps {
    article: HelpArticle;
}

const HelpArticleView: React.FC<HelpArticleViewProps> = ({ article }) => {
    const { t } = useTranslation();

    return (
        <div className="px-5 py-4">
            <h2 className="text-2xl font-semibold mb-5">{t(article.titleKey)}</h2>
            <div className="space-y-5">
                {article.sections.map((section) => (
                    <section key={section.headingKey}>
                        <h3 className="text-base font-semibold mb-1">{t(section.headingKey)}</h3>
                        <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-line">
                            {t(section.bodyKey)}
                        </p>
                    </section>
                ))}
            </div>
        </div>
    );
};

export default HelpArticleView;
